module.exports = __webpack_public_path__ + "static/img/Xavier.Campbell.608c42f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Xavier.Campbell.jpg
// module id = 0vaV
// module chunks = 0